import { useState } from "react";
import { Button, Modal, Space, Typography, message } from "antd";
import "./SiderModal.scss";
import { ModalXIcon } from "../../../../../../assets/icons";
import { sortBy } from "lodash";
import { fileIcons } from "../../../../../Documentation/View/documentationViewData";
import { RedCloseIcon } from "../../../../../Documentation/View/assets";
import { DeleteIcon } from "../../../../../Intervistat/Kandidatet/Kategorite/Image";
import { API } from "../../../../../../helpers/API/amplifyApi";
import { useAuth } from "../../../../../../authentication/authHelpers";
import dayjsTZ from "../../../../../../utils/dayjs";
import { problematikat as problematikatReducer } from "../../../../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { driveApi } from "../../../../../DriveRequest";
import MondayButton from "../../../../../commonComponents/MondayButton/MondayButton";
import MultipleFilePrevieModal from "../MultipleFilePreviewModal/MultipleFilePreviewModal";

const { Text } = Typography;

const SiderModal = ({
  editData,
  onDelete,
  setEditData,
  uploadedFiles,
  setIsFieldTouched,
  isSiderModalVisible,
  setIsSiderModalVisible,
}) => {
  const auth = useAuth();
  const dispatch = useDispatch();
  const { accessToken } = useSelector((state) => state.accessToken);
  const { isDarkMode } = useSelector((state) => state.usersList);

  const driveRequest = driveApi({ accessToken });

  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [currentFile, setCurrentFile] = useState({});

  const handleCancel = () => {
    setIsSiderModalVisible(false);
  };

  //region ON DELETE
  const handleRemove = ({ name, id }) => {
    Modal.confirm({
      title: "Ju po fshini një dokument!",
      className: `confirmModal ${isDarkMode ? "dark" : ""}`,
      icon: <DeleteIcon />,
      centered: true,
      cancelButtonProps: {
        type: "primary",
        style: {
          background: "#ea3943",
          borderColor: "#ea3943",
          borderRadius: "5px",
        },
      },
      onCancel: () => false,
      okButtonProps: {
        className: "ant-btn-confirm",
      },
      cancelText: "Jo, mos e fshi",
      okText: "Po, fshije",
      content: (
        <Space direction="vertical">
          <Text>
            Ju po fshini dokumentin me titull <b>{name}</b>
          </Text>
          <Text>
            Nëse jeni të sigurt për këtë veprim, klikoni
            <span className="text-bold">"Po, fshije"</span>
          </Text>
        </Space>
      ),
      onOk: () => removeFile(id),
    });
  };
  //region >delete()
  const removeFile = async (id) => {
    const filteredArray =
      id && uploadedFiles.filter((files) => files.id !== id);
    const keylog = buildKeylog(filteredArray);
    await API.put("tickets", `/tickets/${editData?.ticketId}`, {
      body: {
        googleDriveFiles: [...filteredArray],
        keylog: [...(editData?.keylog || []), keylog],
      },
    })
      .then(() => {
        try {
          onDelete(id);
          driveRequest.deleteDriveItem(id);
        } catch (err) {
          console.log(err);
        }
        const updatedTicket = {
          ...editData,
          googleDriveFiles: [...filteredArray],
          keylog: [...(editData?.keylog || []), keylog],
        };
        dispatch(problematikatReducer(updatedTicket));
        setEditData(updatedTicket);
        setIsFieldTouched(true);
      })
      .catch((err) => {
        message.error("err: ", err);
        console.log("err: ", err);
      });
  };

  //region >buildKeylog()
  const buildKeylog = (array) => {
    return {
      activity: "Ndryshuar",
      author: `${auth?.user?.given_name} ${auth?.user?.family_name}`,
      changeDate: dayjsTZ().valueOf(),
      field: "Skedarë",
      oldValue: editData?.googleDriveFiles?.map((el) => el.name),
      newValue: array.map((el) => el.name),
    };
  };

  //region ON DOC CLICK
  const handleDocumentClick = async (file) => {
    message.loading({
      content: "Loading file...",
      key: "loadingFile",
      duration: 0,
    });
    try {
      const preview = await driveRequest.getImageSrc(file.id);
      setCurrentFile({
        ...preview,
        url: file.url,
        mimeType: file.mimeType,
        id: file.id,
        name: file.name,
      });
      setPreviewModalVisible(true);
      message.destroy("loadingFile");
    } catch (err) {
      message.error({
        content: "Something went wrong while getting the file",
        key: "loadingFile",
      });
      console.log("Error getting files: ", err);
    }
  };

  //region RETURN
  return (
    <div>
      <Modal
        centered={true}
        width={315}
        className={`siderModal ${
          isDarkMode ? "dark darkHeader" : "lightHeader"
        }`}
        mask={false}
        maskClosable={false}
        title="Dokumente"
        open={isSiderModalVisible}
        destroyOnHidden={true}
        onCancel={handleCancel}
        wrapClassName={"siderProblemsModal"}
        closeIcon={<ModalXIcon />}
        footer={[
          <MondayButton className="mondayButtonRed" onClick={handleCancel}>
            Mbyllni faqen
          </MondayButton>,
        ]}
      >
        <div className="uploadedFilesSection">
          {sortBy(uploadedFiles, "lastEditedUtc")
            .reverse()
            ?.map((file) => {
              const { name = "", id } = file;
              const fileExtension = name.split(".").pop();

              return (
                <div className="fileCard" key={id}>
                  <div className="uploadedFile">
                    <div
                      className="uploadFileName"
                      onClick={() => handleDocumentClick(file)}
                    >
                      <span className="uploadedFileIcon">
                        {fileIcons({ type: fileExtension }) ||
                          fileIcons({
                            type: "image",
                            fill: isDarkMode ? "#e6e6e6" : "#323338",
                          })}
                      </span>
                      <span className="fileName">{name}</span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        width: 20,
                      }}
                    >
                      <Button
                        className="closeIconContainer"
                        type="ghosted"
                        onClick={() => handleRemove({ name, id })}
                        icon={<RedCloseIcon className="closeIcon" />}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          <MultipleFilePrevieModal
            {...{
              visible: previewModalVisible,
              setVisible: () => {
                setCurrentFile({});
                setPreviewModalVisible(false);
              },
              setCurrentFile,
              file: currentFile,
              uploadedFiles,
              driveRequest,
            }}
          />
        </div>
      </Modal>
    </div>
  );
};

export default SiderModal;
